export default "__VITE_ASSET__DmiGgT6F__"